import React from "react";
import Required from "../Required";

const Headercomponent = (props) => {
  const { index, ind, name, required } = props;

  return (
    <React.Fragment>
      <div className="pb-2 text-medium text-gray-500 text-sm">
        {name && (
          <label htmlFor={index?.toString()?.concat(ind)}>
            {name} {required && <Required />}
          </label>
        )}
      </div>
    </React.Fragment>
  );
};

export default Headercomponent;
